export const openInfo = () => {
  return {
    type: "OPEN_INFO",
  };
};

export const closeInfo = () => {
  return {
    type: "CLOSE_INFO",
  };
};

export const toggleSidebar = () => {
  return {
    type: "TOGGLE_SIDEBAR",
  };
};
